<template>
  <span ref="textfield">
    <v-row v-if="label" class="my-0 ellipsis" no-gutters>
      <span class="_subtitleFormFont">{{ label }}:</span>
    </v-row>
    <v-textarea
      v-if="!currency"
      class="pa-0 noMarginPreffix form-textarea-v2"
      style="border-radius: 8px;"
      dense
      filled
      outlined
      flat
      v-model="selectedValue"
      :hide-details="hideDetails"
      :required="required"
      :height="height"
      :validate-on-blur="validateOnBlur"
      :error-messages="errorMessages"
      :disabled="disabled"
      :readonly="readonly"
      :loading="loading"
      :solo="solo"
      :placeholder="placeholder"
      :background-color="backgroundColor"
      :rules="rules"
      :type="type"
      :suffix="suffix"
      :prefix="prefix"
      @change="$emit('change', $event)"
      @input="$emit('input', $event)"
      @blur="$emit('blur', $event)"
      @click="$emit('click')"
      @keydown="$emit('keydown', $event)"
    >
      <template v-slot:prepend-inner>
        <i :class="`${iconPosition} ${icon}`"></i>
      </template>
    </v-textarea>
  </span>
</template>

<script>
  export default {
    props: {
      width: {type: String, default: '100%'},
      height: {type: String, default: '100px'},
      backgroundColor: {type: String, default: '#F6F7F7'},
      showBorder: {type: Boolean, default: false},
      icon: {type: String},
      iconSize: {type: String, default: 'small'},
      iconPosition: {type: String, default: 'mt-1 mr-1'},
      value: { required: true },
      label: {type: String, required: false},
      placeholder: {type: String, required: false},
      required: {type: Boolean, default: false},
      validateOnBlur: {type: Boolean, default: false},
      disabled: {type: Boolean, default: false},
      loading: {type: Boolean, default: false},
      solo: {type: Boolean, default: false},
      errorMessages: {required: false, default: null},
      rules: {required: false},
      readonly: {required: false, default: false},
      hideDetails: {required: false, default: false},
      type: {required: false, default: 'text'},
      suffix: {required: false},
      prefix: {required: false},
      currency: {type: Boolean, default: false}
    },

    data () {
      return {
        currencyOptions: {
          currency: null,
          autoDecimalMode: true
        }
      }
    },

    computed: {
      selectedValue: {
        get () {
          return this.value
        },
        set (v) {
          return this.$emit('input', v)
        }
      }
    }
  }
</script>

<style scoped>
.noMarginPreffix .v-input__control .v-input__slot .v-text-field__slot .v-text-field__prefix {
  margin: 0 !important;
}

.form-textarea-v2 .v-input__control {
  height: auto !important;
}

.form-textarea-v2 {
  font-size: 0.9rem !important;
  font-weight: 400 !important;
}

.v-text-field /deep/ fieldset {
  border-color: #EDEDF1 !important;
}
</style>
